import React, { useEffect, useRef } from "react";
import BookingComponent from "../components/BookingComponent";

function Register() {
    const calendlyRef = useRef(null);
    const initializedRef = useRef(false);

    useEffect(() => {
        if (initializedRef.current) return;
        initializedRef.current = true;

        const initCalendly = () => {
            if (!calendlyRef.current) return;

            // 🔑 Clear container to prevent duplicates
            calendlyRef.current.innerHTML = "";

            window.Calendly.initInlineWidget({
                url: "https://calendly.com/theoutpostgentlemen-info",
                parentElement: calendlyRef.current,
            });
        };

        if (!window.Calendly) {
            const script = document.createElement("script");
            script.src = "https://assets.calendly.com/assets/external/widget.js";
            script.async = true;
            script.onload = initCalendly;
            document.body.appendChild(script);
        } else {
            initCalendly();
        }
    }, []);

    return (
        <div>
            {/* Hero Header */}
            <div className="container-fluid bg-primary py-5 mb-5 hero-header">
                <div className="container py-5">
                    <div className="row justify-content-center py-5">
                        <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
                            <h1 className="display-3 text-white animated slideInDown">
                               Schedule a Meeting
                            </h1>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb justify-content-center">
                                    <li className="breadcrumb-item">
                                        <a href="/">Home</a>
                                    </li>
                                    <li
                                        className="breadcrumb-item text-white active"
                                        aria-current="page"
                                    >
                                      Register
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            {/* Process Start */}
            <div className="container-xxl py-5">
                <div className="container">
                    <div className="text-center pb-4 wow fadeInUp" data-wow-delay="0.1s">
                        <h6 className="section-title bg-white text-center text-primary px-3">
                            Let's Meet
                        </h6>
                        <h1 className="mb-5">Every journey begins with a simple step!</h1>
                    </div>

                    <div className="row gy-5 gx-4 justify-content-center">
                        <div
                            className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
                            data-wow-delay="0.1s"
                        >
                            <div className="position-relative border border-primary pt-5 pb-4 px-4">
                                <div
                                    className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                                    style={{ width: 100, height: 100 }}
                                >
                                    <i className="fa fa-calendar fa-3x text-white" />
                                </div>

                                <h5 className="mt-4"> Schedule a Quick Call </h5>
                                <hr className="w-25 mx-auto bg-primary mb-1" />
                                <hr className="w-50 mx-auto bg-primary mt-0" />
                                <p className="mb-0">
                                  Let's get started by getting to know each other.
                                </p>
                            </div>
                        </div>

                        <div
                            className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
                            data-wow-delay="0.3s"
                        >
                            <div className="position-relative border border-primary pt-5 pb-4 px-4">
                                <div
                                    className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                                    style={{ width: 100, height: 100 }}
                                >
                                    <i className="fa fa-file fa-3x text-white" />
                                </div>

                                <h5 className="mt-4">Traveler Intake</h5>
                                <hr className="w-25 mx-auto bg-primary mb-1" />
                                <hr className="w-50 mx-auto bg-primary mt-0" />
                                <p className="mb-0">
                                    Complete the intake form.
                                </p>
                            </div>
                        </div>

                        <div
                            className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
                            data-wow-delay="0.5s"
                        >
                            <div className="position-relative border border-primary pt-5 pb-4 px-4">
                                <div
                                    className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                                    style={{ width: 100, height: 100 }}
                                >
                                    <i className="fa fa-compass fa-3x text-white" />
                                </div>

                                <h5 className="mt-4">Curated Travel</h5>
                                <hr className="w-25 mx-auto bg-primary mb-1" />
                                <hr className="w-50 mx-auto bg-primary mt-0" />
                                <p className="mb-0">
                                    Explore your outpost options
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Process Start */}
            <div className="text-center pb-0 wow fadeInUp" data-wow-delay="0.1s">
                <h6 className="section-title bg-white text-center text-primary px-3">
                    Schedule a Video Call
                </h6>
                {/* <h1 className="mb-5">3 Simple Steps</h1> */}
            </div>

            {/* Calendly Embed */}
            {/* <div className="container ">
                <div
                    ref={calendlyRef}
                    style={{ minWidth: "320px", height: "700px" }}
                />
            </div> */}
            <BookingComponent/>
        </div>
    );
}

export default Register;
